import React from "react";
import { T } from "../theme";

// A page-level notice: "warn" (amber) for something the reader should know,
// "error" (red) for something that didn't happen. Optional action button.
export default function Banner({ tone = "warn", message, children, actionLabel, onAction }) {
  const color = tone === "error" ? T.statusOff : T.statusRisk;
  const bg = tone === "error" ? T.statusOffBg : T.statusRiskBg;
  return (
    <div role={tone === "error" ? "alert" : "status"} style={{ display: "flex", alignItems: "center", gap: 12, background: bg, border: `1px solid ${color}`, borderRadius: T.radiusMd, padding: "12px 16px", marginBottom: 16, fontFamily: T.fontSans }}>
      <div style={{ flex: 1, minWidth: 0, fontSize: 13, color: T.root, lineHeight: 1.5 }}>{message}{children}</div>
      {actionLabel && (
        <button onClick={onAction} style={{ flexShrink: 0, padding: "6px 14px", fontSize: 12, fontWeight: 600, color: T.fgOnDark, background: color, border: "none", borderRadius: T.radiusSm, cursor: "pointer", fontFamily: T.fontSans }}>{actionLabel}</button>
      )}
    </div>
  );
}
